export default "__VITE_ASSET__DVnRvjTH__"